<template>
  <div class="home-bg">
    <van-pull-refresh v-model="isRefreshing" @refresh="onRefresh">
      <div>
        <!--最新测试结果-->
        <section class="new-data-result">
          <div>
            <div class="left">{{testTime}}</div>
            <div class="sy-cell_flexEnd right">
              <span>{{bsTimeStr}}&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div class="near-one-data">
              <span v-if="bsStatus === '正常'" class="nume white-font-color">{{bs}}</span>
              <span v-else-if="bsStatus === '偏高'" class="nume red-font-color">{{bs}}</span>
              <span v-else class="nume orange-font-color">{{bs}}</span>
              <img v-if="bsStatus === '偏高'" src="../../../assets/images/test/top2.png"/>
              <img v-if="bsStatus === '偏低'" src="../../../assets/images/test/buttom2.png"/>
              <div class="unit">mmlo/L</div>
            </div>
          </div>
        </section>

        <div class="heart" align="center">
          <div class="heart-div1 div-float-left">
            <div style="margin-top: 8%">
              <div><img src="../../../assets/images/near/heart.png" style="width: 40px;height: 25.5px;"/></div>
              <div>
                <span v-if="hbStatus === '正常'" class="heart-font-val white-font-color">{{hb}}&nbsp;</span>
                <span v-else-if="hbStatus === '偏高'" class="heart-font-val red-font-color">{{hb}}&nbsp;</span>
                <span v-else class="heart-font-val orange-font-color">{{hb}}&nbsp;</span>
                <img v-if="hbStatus === '偏高'" class="img-arrow" src="../../../assets/images/test/top.png"/>
                <img v-if="hbStatus === '偏低'" class="img-arrow" src="../../../assets/images/test/buttom.png"/>
              </div>
              <div><span class="heart-font">心率</span></div>
            </div>
          </div>
          <div class="heart-div2 div-float-left fleft">
            <div style="margin-top: 8%">
              <div><img src="../../../assets/images/near/hemoglobin.png" style="width: 40px;height: 25.5px;"/></div>
              <div>
                <span v-if="hlStatus === '正常'" class="heart-font-val white-font-color">{{hemoglobin}}&nbsp;</span>
                <span v-else-if="hlStatus === '偏高'" class="heart-font-val red-font-color">{{hemoglobin}}&nbsp;</span>
                <span v-else class="heart-font-val orange-font-color">{{hemoglobin}}&nbsp;</span>
                <img v-if="hlStatus === '偏高'" class="img-arrow" src="../../../assets/images/test/top.png"/>
                <img v-if="hlStatus === '偏低'" class="img-arrow" src="../../../assets/images/test/buttom.png"/>
              </div>
              <div><span class="heart-font">血红蛋白</span></div>
            </div>
          </div>
        </div>

        <div class="heart" align="center">
          <div class="heart-div3 div-float-left">
            <div style="margin-top: 8%">
              <div><img src="../../../assets/images/near/oxygen.png" style="width: 40px;height: 25.5px;"/></div>
              <div>
                <span v-if="boStatus === '正常'" class="heart-font-val white-font-color">{{bo}}&nbsp;</span>
                <span v-else-if="boStatus === '偏高'" class="heart-font-val red-font-color">{{bo}}&nbsp;</span>
                <span v-else class="heart-font-val orange-font-color">{{bo}}&nbsp;</span>
                <img v-if="boStatus === '偏高'" class="img-arrow" src="../../../assets/images/test/top.png"/>
                <img v-if="boStatus === '偏低'" class="img-arrow" src="../../../assets/images/test/buttom.png"/>
              </div>
              <div><span class="heart-font">血氧饱和度(%)</span></div>
            </div>
          </div>
          <div class="heart-div4 div-float-left fleft">
            <div style="margin-top: 8%">
              <div><img src="../../../assets/images/near/speed.png" style="width: 40px;height: 25.5px;"/></div>
              <div>
                <span v-if="spStatus === '正常'" class="heart-font-val white-font-color">{{bloodSpeed}}&nbsp;</span>
                <span v-else-if="spStatus === '偏高'" class="heart-font-val red-font-color">{{bloodSpeed}}&nbsp;</span>
                <span v-else class="heart-font-val orange-font-color">{{bloodSpeed}}&nbsp;</span>
                <img v-if="spStatus === '偏高'" class="img-arrow" src="../../../assets/images/test/top.png"/>
                <img v-if="spStatus === '偏低'" class="img-arrow" src="../../../assets/images/test/buttom.png"/>
              </div>
              <div><span class="heart-font">血流速度</span></div>
            </div>
          </div>
        </div>

      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getNearHeartData } from '@/api/health'
import { dateFormat } from '@/utils/tool'
import { Toast } from 'vant'
export default {
  data() {
    const date = new Date()
    date.setMonth(date.getMonth() - 1)
    return {
      isRefreshing: false,
      // 血糖
      testTime: null,
      bsTimeStr: '',
      bs: 0,
      bsStatus: '',
      // 血流速度
      bloodSpeed: 0,
      spStatus: '',
      // 血红蛋白
      hemoglobin: 0,
      hlStatus: '',
      // 心率
      hb: 0,
      hbStatus: '',
      // 血氧
      bo: 0,
      boStatus: ''
    }
  },
  created() {
    this.getSugarData()
  },
  methods: {
    getSugarData: function() {
      var this_ = this
      var toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '加载中...'
      })
      getNearHeartData().then(res => {
        if (res && res.data.code === 0) {
          var data = res.data.data
          if (data) {
            var bsData = data.firstBloodSugar
            var hbData = data.firstHeartBeat
            var oxyData = data.firstBloodOxygen
            if (bsData) {
              this_.bsTimeStr = bsData.state
              var state = bsData.state2.split(',')
              this_.testTime = dateFormat(bsData.testTime, 'yyyy-MM-dd HH:mm')
              this_.bs = bsData.bs
              this_.bsStatus = state[0]
              // 血流速度
              this_.bloodSpeed = bsData.bloodSpeed
              this_.spStatus = state[1]
              // 血红蛋白
              this_.hemoglobin = bsData.hemoglobin
              this_.hlStatus = state[2]
            }
            if (hbData) {
              this_.hb = hbData.hb
              this_.hbStatus = hbData.state2
            }
            if (oxyData) {
              this_.bo = oxyData.bo
              this_.boStatus = oxyData.state2
            }
          }
        }
        toast.clear()
      })
    },
    onRefresh() {
      setTimeout(() => {
        // this.$toast('刷新成功')
        this.isRefreshing = false
        this.getSugarData()
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
  .img-arrow{
    height: 14px;
    padding-top: 1.5px;
  }
  .heart{
    padding-left: 4%;
    padding-bottom: 4%;
    width: 100%;
    margin-top: 10px;
  }
  .div-float-left{
    float: left;
  }
  .fleft{
    margin-left: 4%;
  }
  .heart-font{
    font-size:13px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:21px;
  }
  .heart-font-val{
    font-size:18px;
    font-family:PingFangSC-Medium;
    font-weight:500;
    line-height:21px;
  }
  .red-font-color{
    color:rgba(255,0,0,1);
  }
  .white-font-color{
    color:rgba(255,255,255,1);
  }
  .orange-font-color{
    color:rgba(255,234,192,1);
  }
  .heart-div1{
    width: 45.5%;
    height: 104px;
    border-radius:5px;
    background-image: -moz-linear-gradient(top, #57E9EB, #59CBDD); /* Firefox */
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #57E9EB), color-stop(1, #59CBDD)); /* Saf4+, Chrome */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#57E9EB', endColorstr='#59CBDD', GradientType='0'); /* IE*/
  }
  .heart-div2{
    width: 45.5%;
    height: 104px;
    border-radius:5px;
    background-image: -moz-linear-gradient(top, #FF8246, #FE5A35); /* Firefox */
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #FF8246), color-stop(1, #FE5A35)); /* Saf4+, Chrome */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FF8246', endColorstr='#FE5A35', GradientType='0'); /* IE*/
  }  .heart-div3{
       margin-top: 15px;
       width: 45.5%;
       height: 104px;
       border-radius:5px;
       background-image: -moz-linear-gradient(top, #A0B0FF, #6A7FFF); /* Firefox */
       background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #A0B0FF), color-stop(1, #6A7FFF)); /* Saf4+, Chrome */
       filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#A0B0FF', endColorstr='#6A7FFF', GradientType='0'); /* IE*/
     }

  .heart-div4{
    margin-top: 15px;
    width: 45.5%;
    height: 104px;
    border-radius:5px;
    background-image: -moz-linear-gradient(top, #FFBA00, #FF9702); /* Firefox */
    background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #FFBA00), color-stop(1, #FF9702)); /* Saf4+, Chrome */
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#FFBA00', endColorstr='#FF9702', GradientType='0'); /* IE*/
  }
  .home-bg{
    min-height: calc(100vh - 1rem);
    background: white;
  }
  .new-data-result{
    width: 369px;
    height:191px;
    margin: 9px auto 0;
    background: url('../../../assets/images/home/new-data-bg.png') no-repeat;
    background-size: 100% 100%;
    padding:12px 11px;
    .left{
      height:18px;
      font-size:13px;
      font-family:PingFangSC-Regular;
      font-weight:200;
      color:rgba(255,255,255,1);
      line-height:36px;
      text-indent: 14px;
      display: inline-block;
    }
    .right{
      width:150px;
      height:34px;
      opacity:0.7;
      font-size:13px;
      font-family:PingFangSC-Regular;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:34px;
      float: right;
      text-align: right;
      img{
        width: 17px;
        height: 17px;
        margin-right: 4px;
      }
    }
    .near-one-data{
      text-align: center;
      padding-top: 31px;
      .nume{
        font-family:PingFangSC-Medium;
        font-size:63px;
        font-weight: 500;
        line-height: 50px;
        display: inline-block;
        height: 50px;
      }
      .unit{
        font-family:PingFangSC-Regular;
        font-size:16px;
        color:rgba(255,255,255,1);
        line-height:21px;
      }
    }
  }
  .van-nav-bar .van-icon {
    vertical-align: middle;
    margin-top: -3px;
  }
</style>
